module.exports = "<img\n    style=\"width: 100%; object-fit: cover;\"\n    ng-if=\"mapUrl = buildMapUrl()\"\n    ng-src=\"{{ mapUrl }}\"\n/>";